
export default {
  name: 'IconBlok',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
